export default "__VITE_ASSET__5ed515c6__"